import { LOGIN_BASIC_CONFIG } from "@/betby/utils/config";
import { getDeviceId } from "@/betby/adapters/device/deviceIdAdapter";
import { getAuthSnapshot } from "@/betby/api/httpRuntimeAdapter";
import { logger, isDevelopment } from "@/betby/api/httpLogger";
import { md5Hex } from "@/betby/utils/md5";

const API_CONFIG = {
  PRODUCT_ID: "",
  BUSINESS_ID: "",
  PLATFORM: "web",
} as const;

const userIdEncryptionCache = new Map<number, string>();

function getEncryptedUserId(userId: number): string {
  if (userIdEncryptionCache.has(userId)) {
    return userIdEncryptionCache.get(userId)!;
  }

  try {
    const encrypted = md5Hex(String(userId));
    userIdEncryptionCache.set(userId, encrypted);
    return encrypted;
  } catch (error) {
    logger.error("[getEncryptedUserId] 加密失败:", error);
    return String(userId);
  }
}

export function buildHttpHeaderBasic() {
  return {
    deviceId: getDeviceId(),
    appVersion: LOGIN_BASIC_CONFIG.sdk_version_name,
    platform: API_CONFIG.PLATFORM,
  };
}

export function getRequestHeaders(
  customHeaders?: Record<string, string>,
  skipAuth: boolean = false,
): Record<string, string> {
  const snapshot = getAuthSnapshot();
  const userInfo = snapshot.userInfo;

  const productId =
    snapshot.productId != null
      ? String(snapshot.productId)
      : userInfo?.product_id
        ? String(userInfo.product_id)
        : API_CONFIG.PRODUCT_ID;

  const businessId =
    snapshot.businessId != null
      ? String(snapshot.businessId)
      : userInfo?.business_id
        ? String(userInfo.business_id)
        : API_CONFIG.BUSINESS_ID;

  const headers: Record<string, string> = {
    "s-product-id": productId,
    "s-business-id": businessId,
    ...customHeaders,
  };

  if (isDevelopment) {
    logger.debug("[getRequestHeaders] 业务标识:", {
      "s-product-id": productId,
      "s-business-id": businessId,
      source:
        userInfo?.product_id || userInfo?.business_id ? "userInfo" : "default",
    });
  }

  if (!skipAuth) {
    if (snapshot.userId != null) {
      const encryptedUserId = getEncryptedUserId(snapshot.userId);
      headers["s-user-id"] = encryptedUserId;
      logger.debug(
        "[getRequestHeaders] 已添加 s-user-id (加密):",
        encryptedUserId,
        "原始值:",
        snapshot.userId,
      );
    } else {
      logger.warn("[getRequestHeaders] 未获取到 user_id，跳过 s-user-id 添加");
    }
    const logindata = JSON.parse(
      localStorage.getItem("winburst-auth-storage") || "{}",
    );
    const sdkId = logindata?.state?.loginData?.account_info?.sdk_id;
    const encryptedSdkId = md5Hex(
      (sdkId || LOGIN_BASIC_CONFIG.SDK_ID).toString(),
    );
    headers["s-sdk-id"] = encryptedSdkId;
    logger.debug("[getRequestHeaders] 已添加 s-sdk-id (加密):", encryptedSdkId);
  } else {
    logger.debug("[getRequestHeaders] 跳过用户相关头添加（登录接口）");
  }

  logger.debug("[getRequestHeaders] 最终请求头:", headers);
  return headers;
}
